import { ActionType } from 'typesafe-actions';
import { createDataFetchActions } from '../dataFetching/generators';

export const cmsLinkedBannersActions = createDataFetchActions(
    '@CMS/LINKED_BANNERS',
    ({ apiService }) => (cmsBlockKey: string) => apiService.shopApi.getCMSStaticBlockLinkBanners(cmsBlockKey),
    cmsBlockKey => cmsBlockKey
);

export const cmsStaticPageActions = createDataFetchActions(
    '@CMS/STATIC_PAGES',
    ({ apiService }) => (pageKey: string) => apiService.shopApi.getCMSStaticPage(pageKey),
    pageKey => pageKey
);

export type CmsLinkedBannerActions = ActionType<typeof cmsLinkedBannersActions.actions>;
export type CmsStaticPageActions = ActionType<typeof cmsStaticPageActions.actions>;

export const fetchCMSLinkedBannersIfNeeded = cmsLinkedBannersActions.thunk;
export const fetchCMSStaticPageIfNeeded = cmsStaticPageActions.thunk;
